export const stepNames = {
  BANK_ACCOUNT: 'bank_account',
  FIRST_STEPS_COMPLETED: 'first_steps_completed',
  LOGISTIC_ADDRESS: 'company_account',
  SUBSCRIPTION: 'subscription_paid',
};

export const mixPanelEventTitles = {
  ONBOARDING: 'First steps - Viewed first steps page',
  ONBOARDING_STEPS_CARDS: {
    company_account: 'First steps - clicked on logistical address card',
    bank_account: 'First steps - clicked on receive for your sales card',
    subscription_paid: 'First steps - clicked on choose plan card',
  },
  ONBOARDING_STEPS_LINKS: {
    company_account: 'First steps - clicked on logistical address button',
    bank_account: 'First steps - clicked on receive for your sales button',
    subscription_paid: 'First steps - clicked on choose plan button',
  },
};

export const ALERT_VARIATION = {
  danger: 'danger',
  alternate: 'alternate',
  shadow: 'shadow',
  warning: 'warning',
};

export const HIDE_PLAN_CHOICE_BUTTON_REGEX = 'bundle';
